import { render, staticRenderFns } from "./additional.vue?vue&type=template&id=092938c6"
import script from "./additional.vue?vue&type=script&lang=js"
export * from "./additional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('092938c6')) {
      api.createRecord('092938c6', component.options)
    } else {
      api.reload('092938c6', component.options)
    }
    module.hot.accept("./additional.vue?vue&type=template&id=092938c6", function () {
      api.rerender('092938c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/additional.vue"
export default component.exports